import { render, staticRenderFns } from "./StatementBookListReceipt.vue?vue&type=template&id=387358ac&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./StatementBookListReceipt.vue?vue&type=script&lang=js&"
export * from "./StatementBookListReceipt.vue?vue&type=script&lang=js&"
import style0 from "./StatementBookListReceipt.vue?vue&type=style&index=0&id=387358ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387358ac",
  null
  
)

component.options.__file = "StatementBookListReceipt.vue"
export default component.exports